import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from "src/app/Service/axios";
declare let $: any;

@Component({
  selector: 'app-tanker-illegal-water-sources',
  templateUrl: './tanker-illegal-water-sources.component.html',
  styleUrls: ['./tanker-illegal-water-sources.component.css']
})
export class TankerIllegalWaterSourcesComponent implements OnInit {

  data: any = [];
  searchList = [];

  searchForm: FormGroup = this.FormBuilder.group({
    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
    strSDate: new FormControl(''),
    strEDate: new FormControl(''),
  })

  constructor(
    private otherService: OtherService,
    private FormBuilder: FormBuilder,
    private router: Router, private gurdService: GurdServiceService,
    private Notification: NotificationService
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      $("#illegal-water-sources-modal").modal("show");
    }, 100);
  }

  fetchData = async () => {
    let model = this.searchForm.value;
    this.otherService.Showspinner();
    let res = JSON.parse((await axios.post(`Tanker_Report_Feeding_TankersDetail`, model)).data.toString());
    this.otherService.nonespinner();

    if (res.ISSessionExpired == true) {
      this.Notification.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: 'xxz12z110' } });
      return;
    }

    if (res.iResult == 0) {
      this.Notification.showError(res.strError);
      this.router.navigateByUrl('/')
      return;
    }

    if (!res.length) {
      this.Notification.showError('نتیجه ایی یافت نشد!');
      this.router.navigateByUrl('/')
      return;
    }

    localStorage.removeItem('supplyDetails');
    const encrypted = this.gurdService.encrypt(JSON.stringify(res));
    localStorage.setItem('supplyDetails', encrypted);

    const urlTree = this.router.createUrlTree(['tanker', 'show-all-in-map']);
    const serializedUrl = this.router.serializeUrl(urlTree);
    window.open(serializedUrl, '_self');


  };


}